import React from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

export const NEREUS_CAUTION_TEXT =
  'Nereus is an AI that is still learning — his answers can be incomplete or wrong. Treat them as a starting point, never as instruction or a dive plan.';

interface NereusCautionProps {
  /** "banner" sits under a chat header; "inline" is a small caption under a single reply. */
  variant?: 'banner' | 'inline';
}

/** Persistent reminder that Nereus is AI and fallible, shown wherever his words appear. */
const NereusCaution: React.FC<NereusCautionProps> = ({ variant = 'banner' }) => {
  if (variant === 'inline') {
    return (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic', mt: 0.25 }}>
        AI-generated by Nereus, who is still learning — verify before relying on it; not a dive plan.
      </Typography>
    );
  }
  return (
    <Box
      role="note"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.75,
        px: 1.5,
        py: 0.75,
        bgcolor: 'warning.light',
        color: 'warning.contrastText',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <InfoOutlined sx={{ fontSize: 16, mt: '2px' }} />
      <Typography variant="caption" sx={{ lineHeight: 1.35 }}>{NEREUS_CAUTION_TEXT}</Typography>
    </Box>
  );
};

export default NereusCaution;
